import * as React from 'react';

import styles from './secondary-sidebar.module.css';

export function SecondarySidebarLoading() {
    return (
        <div className={styles['secondary-sidebar-wrapper']}>
            <div className={styles['secondary-sidebar']}>
                <div className={styles['nut-secondary-sidebar--loading-bar']}></div>
                <div className={styles['nut-secondary-sidebar--loading-bar']}></div>
                <div className={styles['nut-secondary-sidebar--loading-bar']}></div>
                <div className={styles['nut-secondary-sidebar--loading-bar']}></div>
                <div className={styles['nut-secondary-sidebar--loading-bar']}></div>
            </div>
        </div>
    );
}
